'use client'

// src/components/SentryUserSync.tsx
// Keeps Sentry's user context in sync with the NextAuth session.
// Mounted once in the root layout; renders nothing.

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'
import { setUser } from '@/lib/sentry'

export default function SentryUserSync() {
  const { data: session, status } = useSession()

  useEffect(() => {
    if (status === 'loading') return
    const user = session?.user as { id?: string | null } | undefined

    // Only the opaque id — no email/PII. See setUser() in @/lib/sentry. (#818)
    if (user?.id) {
      setUser({ id: user.id })
    } else {
      setUser(null)
    }
  }, [session, status])

  return null
}
